module.exports = __webpack_public_path__ + "img/start-1.04467d95.png";